/* eslint-disable no-void */
import './index.less';
import React from 'react';
import { Pagination } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  getSearchParams,
  NormalObj,
  stringifySearchParams,
  getStudySectionId,
  MyIcon,
} from '../../util';
import { RouteComponentProps } from 'react-router';
import * as videoResourceAction from '../../redux/action/video-resource.action';
import * as menuAction from '../../redux/action/menu.action';
import * as baseAction from '../../redux/action/base.action';
import { updateSearchValue } from '../../redux/action/createSearch.action';
import Tablist from '../../components/Tablist';
import { highLightReplace } from '../GlobalSearch/lib/highLight';
import Empty from '../Empty';
import withHiddenLabel from '../../components/withHiddenLabel';
import CreateSearch from '../../components/CreateSearch';
import { VideoResourceList } from './video-resource-list';
import ColumnList from '../../components/ColumnList';
import { Empty as AntdEmpty } from 'antd';
import { VideoResourceItem, videoResourceTypes } from './types';

interface obj {
  [key: string]: any;
}

const DEFAULT_ACTIVE_KEY = 0;
const DEFAULT_VIDEO_RESOURCE_TYPE_ID = videoResourceTypes[DEFAULT_ACTIVE_KEY].value;

interface P extends RouteComponentProps {
  tree: [];
  studySections: [];
  subjects: [];
  grades: [];
  textBooks: [];
  videoResourceList: {
    list: VideoResourceItem[];
    page: {
      size: number;
      number: number;
      totalPages: number;
      totalElements: number;
    };
  };
  schoolPeriods: [];
  history: any;
  registerGetDataFn: any;
  resourceRootOption: any[];
  rootOption: any[];
  addressBarColumnId: string;
  updateCurrentRootType: any;
  resetLists: () => {};
  menusConfig: { [key: string]: any };
  hiddenLabel: boolean; // 由 HOC 注入
}
const initialParams = {
  size: 10,
  current: 1,
  name: '',
  keyword: '',
  subjectId: '',
  schoolPeriod: '',
  gradeId: '',
  schoolSection: '',
  videoResourceTypeId: DEFAULT_VIDEO_RESOURCE_TYPE_ID,
  startTime: '',
  endTime: '',
};

const initialFilterState = {
  activeGradeKey: DEFAULT_ACTIVE_KEY,
  activeSchoolSectionKey: DEFAULT_ACTIVE_KEY,
  activeSchoolPeriodKey: DEFAULT_ACTIVE_KEY,
  activeReleaseStateKey: DEFAULT_ACTIVE_KEY,
  activeSubjectKey: DEFAULT_ACTIVE_KEY,
  activeVideoResourceTypeKey: DEFAULT_ACTIVE_KEY,
  activeWeekKey: undefined,
};

function getDefaultCode(data: obj[] = []) {
  return data[DEFAULT_ACTIVE_KEY] ? data[DEFAULT_ACTIVE_KEY].code || '' : '';
}

class OtherResourceList extends React.Component<P, any> {
  params: obj = {};
  filterData: obj = { ...initialParams };
  createCourse: boolean;
  createArticle: boolean;
  leftNavType: string | null;
  searchParams: NormalObj;
  constructor(props: P) {
    super(props);
    this.state = {
      root: [...this.props.resourceRootOption],
      disabled: true,
      chapterId: [],
      minHeight: window.innerHeight - 312,
      materialId: '',
      ...initialFilterState,
      isRoot: true, // 是否具有该权限
      addressBarColumnId: '',
      filterConfig: {
        showSubject: false,
        showGrade: false,
        showSchoolPeriod: false,
        showMaterial: false,
      },
    };
    this.searchParams = getSearchParams(props.location.search);
    this.leftNavType = 'create';
    this.createCourse = false;
    this.createArticle = false;
    this.params = getSearchParams(props.location.search);
    this.resetFilterData();
    this.resize = this.resize.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.previewCourse = this.previewCourse.bind(this);
    this.videoResourceHighLight = this.videoResourceHighLight.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps: P) {
    this.params = getSearchParams(nextProps.location.search);
    this.filterData.columnId = this.params.id || '';
    if (nextProps.addressBarColumnId !== this.props.addressBarColumnId) {
      // 同类型栏目切换时组件不卸载；addressBarColumnId 会先于 location.search 更新
      this.params.id = nextProps.addressBarColumnId;
      this.filterData.columnId = nextProps.addressBarColumnId;
      this.props.resetLists();
      this.initRootData();
    }
  }

  resetFilterData() {
    this.filterData = {
      ...initialParams,
      columnId: this.props.addressBarColumnId || this.params.id || '',
    };
  }

  componentDidMount() {
    this.props.resetLists();
    // 注册获取数据方法
    this.props.registerGetDataFn(this.handleMenuClick);
    this.initRootData();
  }
  initRootData = async () => {
    const { rootOption, resourceRootOption } = this.props;
    const result = [...resourceRootOption];
    this.leftNavType = rootOption[0] ? rootOption[0].type : '';
    if (window.localStorage.getItem('ROOTTYPE')) {
      this.leftNavType = window.localStorage.getItem('ROOTTYPE');
    } else {
      this.props.updateCurrentRootType(this.leftNavType);
    }

    if (result.length > 0 && this.params.type === '3') {
      this.setState({ root: result }, () => this.handleMenuClick(this.leftNavType));
    } else {
      this.setState({
        isRoot: false,
      });
    }
  };
  // 获取基础数据
  getBasicsData = async () => {
    if (this.leftNavType === 'create') {
      return;
    }

    this.setState({
      filterConfig: {
        showGrade: true,
        showSchoolPeriod: true,
        showSubject: true,
        showVideoResourceType: true,
      },
    });
    const studySectionCode = getStudySectionId();
    const columnId = this.props.addressBarColumnId || this.searchParams.id;

    const [, subjects, grades] = await Promise.all([
      baseAction.getFollowSchoolPeriod(columnId), // 获取学届
      baseAction.getFollowSubjects(columnId, studySectionCode),
      baseAction.getFollowGrades(columnId, studySectionCode),
    ]);

    this.syncDefaultFilterData(grades, subjects);
  };

  syncDefaultFilterData(grades: obj[] = [], subjects: obj[] = []) {
    this.filterData.gradeId = getDefaultCode(grades);
    this.filterData.subjectId = getDefaultCode(subjects);
    this.filterData.videoResourceTypeId = DEFAULT_VIDEO_RESOURCE_TYPE_ID;
  }

  resize() {
    this.setState({ minHeight: window.innerHeight - 302 });
  }
  screenChange() {
    window.addEventListener('resize', this.resize);
  }
  /**
   * 收集筛选条件
   * @param o 筛选条件 { type: { value } } || value
   * @param key 索引 index
   */
  handleChange(o: { [key: string]: any }, key?: number | string) {
    this.filterData.current = 1;
    const obj: any = {};
    if (o.schoolPeriod) {
      this.filterData.schoolPeriod = o.schoolPeriod.code;
      obj.activeSchoolPeriodKey = key;
    } else if (o.grade) {
      this.filterData.gradeId = o.grade.code;
      // this.textbookParams.gradeCodes = o.grade.code;
      obj.activeGradeKey = key;
      // 在选择年级之后 要重置 教材章节的筛选条件
      // obj.chapterId = [];
      // obj.disabled = true;
      // obj.materialId = '';
      // this.filterData.chapterId = '';
      // this.filterData.materialId = '';
      // baseAction.getTextbooks(this.textbookParams)
    } else if (o.subject) {
      this.filterData.subjectId = o.subject.code;
      obj.activeSubjectKey = key;
    } else if (o.videoResourceType) {
      this.filterData.videoResourceTypeId = o.videoResourceType.value;
      obj.activeVideoResourceTypeKey = key;
    } else if (o.week) {
      this.filterData.startTime = o.week.startTime;
      this.filterData.endTime = o.week.endTime;
      obj.activeWeekKey = o.week.value;
    }

    updateSearchValue(this.filterData.name);
    this.setState(
      {
        ...obj,
      },
      this.searchData,
    );
  }

  searchData(page?: number) {
    window.scrollTo(0, 0);
    if (page) this.filterData.current = page;
    this.filterData.columnId = this.props.addressBarColumnId || this.filterData.columnId;
    videoResourceAction.getVideoResourceList(this.filterData, this.videoResourceHighLight);
  }

  callback = () => {
    this.filterData.columnId = this.props.addressBarColumnId || this.filterData.columnId;
    videoResourceAction.getVideoResourceList(this.filterData, this.videoResourceHighLight);
  };

  /**
   * 课程搜索高亮
   * @param list 原始列表数据
   * @param type 课程列表类型 0：创建列表  2：同步列表
   * @param analyzesData 拆分的关键字数组
   */
  videoResourceHighLight(list: VideoResourceItem[], analyzesData: string[]) {
    const { name } = this.filterData;
    return (list || []).map((item) => {
      const highLightName =
        analyzesData.length > 0 ? highLightReplace(name, item.name, item.highLightName) : item.name;
      return {
        ...item,
        highLightName,
      };
    });
  }
  /**
   * 预览课程
   * @param item 视频资源项
   */
  previewCourse(item: VideoResourceItem) {
    const search = {
      columnId: this.filterData.columnId,
      type: this.searchParams.leftMenuType,
      videoResourceType: this.filterData.videoResourceTypeId,
      resourceId: item.id,
    };
    window.open(`/resource-preview${stringifySearchParams(search)}`);
  }
  /**
   * 左侧菜单点击
   * @param type 菜单类型 create:我的创建 sync:我的同步
   */
  handleMenuClick = (type: string | null) => {
    const { root } = this.state;
    // 判断是否具有该权限
    const rootResult = root.findIndex((item: any) => item.type === type);
    if (rootResult === -1) {
      menuAction.updateButtonStatus({
        status: false,
        type: 'create_video_resource',
        name: '第三方资源',
      });
      this.setState({ isRoot: false });
      return null;
    }

    this.leftNavType = type;
    this.resetFilterData();
    updateSearchValue(this.filterData.name);
    // 隐藏创建按钮
    menuAction.updateButtonStatus({
      status: false,
      type: 'create_video_resource',
      name: '第三方资源',
    });

    const _active_ = [...root];
    _active_[rootResult].active = true;
    this.setState(
      {
        root: this.transformData(_active_, type),
        disabled: true,
        chapterId: [],
        materialId: '',
        ...initialFilterState,
        isRoot: true,
      },
      async () => {
        if (this.params.type === '3') {
          await this.getBasicsData();
          this.searchData(1);
        }
      },
    );
  };

  transformData(data: NormalObj[], type?: string | null) {
    for (let i = 0, len = data.length; i < len; i++) {
      if (data[i].type === type) {
        data[i].active = true;
      } else {
        data[i].active = false;
      }
    }
    return data;
  }

  hasPage(data: []) {
    if (!data.length) return false;
    if (this.params.type !== '0' && this.params.type !== '1') return false;
    if (data.length === 1) {
      if (this.params.type === '0' && this.createArticle && !this.createCourse) return false;
      if (this.params.type === '1' && this.createCourse && !this.createArticle) return false;
    }
    return true;
  }

  enterSearch = (v: string) => {
    this.filterData.name = v;
    this.searchData(1);
  };

  renderNormalFilter() {
    const { activeGradeKey, activeSubjectKey, activeVideoResourceTypeKey, activeWeekKey } =
      this.state;
    const { showSubject, showGrade, showVideoResourceType } = this.state.filterConfig;
    const { grades, subjects } = this.props;

    const gradeProps = {
      data: grades,
      type: 'grade',
      activeKey: activeGradeKey,
      tabChange: this.handleChange,
      notAddAll: true,
    };
    const subjectProps = {
      data: subjects,
      type: 'subject',
      tabChange: this.handleChange,
      activeKey: activeSubjectKey,
      notAddAll: true,
    };

    const resourceTypeProps = {
      data: videoResourceTypes,
      type: 'videoResourceType',
      tabChange: this.handleChange,
      activeKey: activeVideoResourceTypeKey,
      notAddAll: true,
    };

    const result = [];
    // 如果年级数量大于1，则显示年级筛选
    if (showGrade && grades.length > 1) {
      result.push(<Tablist key={gradeProps.type} {...gradeProps} />);
    }
    // 如果学科数量大于1，则显示学科筛选
    if (showSubject && subjects.length > 1) {
      result.push(<Tablist key={subjectProps.type} {...subjectProps} />);
    }

    if (showVideoResourceType && videoResourceTypes.length > 1) {
      result.push(<Tablist key={resourceTypeProps.type} {...resourceTypeProps} />);
    }

    const weekProps = {
      type: 'week',
      tabChange: this.handleChange,
      activeKey: activeWeekKey,
      notAddAll: true,
      disabledDate: (currentDate: any) => {
        return currentDate && moment(currentDate).isAfter(moment().endOf('day'));
      },
    };
    result.push(<Tablist key={weekProps.type} {...weekProps} />);

    return result;
  }

  render() {
    const { isRoot } = this.state;
    const { videoResourceList } = this.props;
    console.log('🚀 ~ OtherResourceList ~ render ~ videoResourceList:', videoResourceList);
    // const releaseProps = {
    //   type: 'releaseState',
    //   data: [
    //     {
    //       name: '已发布',
    //       value: 1,
    //     },
    //     {
    //       name: '未发布',
    //       value: 0,
    //     },
    //   ],
    //   activeKey: activeReleaseStateKey,
    //   tabChange: this.handleChange,
    // };
    return this.leftNavType === 'sync' ? (
      <div className="video-resource-list-Component">
        <div className="page">
          <ColumnList />
          {isRoot ? (
            <div className="right">
              <div className="search-filter">
                <div className="filter">{this.renderNormalFilter()}</div>
                <div className="create-search">
                  <CreateSearch
                    enterSearch={this.enterSearch}
                    placeholder={'输入关键词搜索'}
                    width={240}
                  />
                </div>
              </div>

              <div
                className={`content ${
                  videoResourceList.list && videoResourceList.list.length === 0 ? 'min-height' : ''
                }`}
              >
                <div className="list">
                  <VideoResourceList
                    items={videoResourceList.list}
                    onWatch={this.previewCourse}
                    type={this.filterData.videoResourceTypeId}
                  />
                </div>
                {!!videoResourceList?.page?.totalElements && (
                  <div className="video-resource-list-pagination">
                    <Pagination
                      current={this.filterData.current}
                      pageSize={this.filterData.size}
                      total={videoResourceList.page.totalElements}
                      size="small"
                      onChange={(page) => this.searchData(page)}
                    />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="right">
              <Empty />
            </div>
          )}
        </div>
      </div>
    ) : (
      <div className="video-resource-list-Component-empty">
        <AntdEmpty
          className="ant-empty-normal custom-empty"
          description="暂无内容"
          image={<MyIcon className="empty-icon" type="iconcontent_null" />}
        />
      </div>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    ...state.VideoResourceList,
    is_exist: state.CourseDetail.is_exist,
    studySections: state.Base.studySectionsList,
    subjects: state.Base.subjectsList,
    grades: state.Base.gradesList,
    schoolPeriods: state.Base.schoolPeriodList,
    textBooks: state.Base.textBooks,
    tree: state.Base.chaptersTree,
    resourceRootOption: state.GlobalCreateSync.resourceRootOption,
    addressBarColumnId: state.GlobalCreateSync.addressBarColumnId,
    rootOption: state.GlobalCreateSync.rootOption,
    menusConfig: state.Menu.menusConfig,
  };
};
const mapDispatchToProps = (dispatch: any, ownProps: any) => ({
  // 注册根据权限获取数据函数
  registerGetDataFn: (fn: any) => dispatch({ type: 'GETDATABYROOT', payload: fn }),
  updateCurrentRootType: (type: string) =>
    dispatch({ type: 'GLOBALCREATESYNCTYPE', payload: type }),
  // 重置列表数据
  resetLists: () => dispatch({ type: 'RESET_LISTS' }),
  ...ownProps,
});
export default withHiddenLabel(connect(mapStateToProps, mapDispatchToProps)(OtherResourceList));
